<template>
    <div class="row">
        <loading :active='isLoading'/>
        <div class="d-none d-lg-block col-lg-2"></div>
        <div class="col-12 col-lg-8">
            <div class="mx-3 mx-md-5 mx-lg-0">
                <form-org 
                    v-model = "user"
                    :invalid = "userInvalid"
                ></form-org>
                <div class="d-flex mt-4">
                    <div class="flex-grow-1">
                        <button class="btn btn-primary" @click="$router.go(-1)"><i class="fas fa-ban me-2"></i>Cancel</button>
                    </div>
                    <button class="btn btn-primary" @click="$router.push('/user/update')"><i class="far fa-user me-2"></i>Update User</button>
                    <button class="btn btn-primary ms-3" @click="submit"><i class="far fa-check-circle me-2"></i>Submit</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import FormOrg from './components/FormOrg.vue';

export default {
    components: { 
        Loading,
        FormOrg,
    },

    mounted() {
        this.isLoading = true;
        axios
            .get('/api/user/details')
            .then(response => {
                console.log(response.data);
                this.user = response.data;
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        submit: function() {
            this.isLoading = true;
            const data = {
                job_title: this.user.job_title ?? '',
                org_name: this.user.org_name ?? '',
                org_building: this.user.org_building ?? '',
                org_address: this.user.org_address ?? '',
                org_city: this.user.org_city ?? '',
                org_state: this.user.org_state ?? '',
                org_zip: this.user.org_zip ?? '',
            };

            axios
                .patch('/api/user-org/update', data)
                .then(response => {
                    console.log(response.data);
                    this.$swal({
                        title: 'User Update Succeded ',
                        text: response.data.session,
                        icon: 'success'
                    });
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.userInvalid = Object.keys(error.response.data.errors);
                        let message = Object.values(error.response.data.errors);
                        message = message.map(m => `<li class="list-group-item">${m}</li>`);
                        message = message.join('');
                        message = `<ul class="list-group">${message}</ul>`;
                        this.$swal({
                            title: 'User Update Failed',
                            html: message,
                            icon: 'warning'
                        });
                    } else {
                        console.error(error);
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    data() {
        return {
            isLoading: false,

            user: {},
            userInvalid: [],
        };
    },


}
</script>